import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from "@apollo/client";
import Cookies from "js-cookie";
import { environmentSelectors } from "store/slices/environment/selector";
import { useSelector } from "react-redux";
import { setApolloClient } from "client/apolloClient";

interface Props {
  children: React.ReactNode;
}

export const ProviderGraphQl = ({ children }: Props) => {
  const environment = useSelector(environmentSelectors.environment);
  const httpLink = new HttpLink({ uri: environment?.REACT_APP_APOLLO_URI });

  const graphqlClientFactory = () => {
    const getToken = (): string => {
      const jwt = Cookies.get("jwtRent");
      return jwt ? `Bearer ${jwt}` : "";
    };

    const authLink = new ApolloLink((operation, forward) => {
      const omitTypename = (key: string, value: string) =>
        key === "__typename" ? undefined : value;

      if (operation.variables && !operation.getContext().hasUpload) {
        // eslint-disable-next-line no-param-reassign
        operation.variables = JSON.parse(
          JSON.stringify(operation.variables),
          omitTypename,
        );
      }
      operation.setContext({
        headers: {
          authorization: getToken(),
        },
      });
      return forward(operation);
    });

    const client = new ApolloClient<NormalizedCacheObject>({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });

    setApolloClient(client);
    return client;
  };

  return (
    <ApolloProvider client={graphqlClientFactory()}>{children}</ApolloProvider>
  );
};
